/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2022
 * @flow
 */

import React from 'react';
import classNames from 'classnames';
import MergedCard from '../../MergedCard';
import classes from './LeftSection.module.css';

const LeftSection = props => {
  return (
    <div className={classes.leftSection}>
      {props?.sectionView ? <SectionView {...props} /> : <EmployeesView {...props} />}
    </div>
  );
};

export default LeftSection;

const SectionView = props => {
  const {
    sectionList,
    primarySelectedSection,
    onSelectPrimary,
    assigned,
    revenueCentersMap,
    onUnAssign,
  } = props;

  const isVisible = eachSection => {
    const { employees } = eachSection;
    let assignedFlag = true;

    if (assigned) {
      assignedFlag = (Array.isArray(employees) && employees.length > 0);
    }

    return (assignedFlag);
  };

  return (
    sectionList.map(eachSection => {
      const section = eachSection.Section;
      const employees = Array.isArray(eachSection.employees) ? eachSection.employees : [];
      return (!isVisible(eachSection) ? null :
        <div key={section.id} className={classNames({ [classes.tableGroup]: true, [classes.group]: employees.length > 0 })}>
          <MergedCard
            active={primarySelectedSection && primarySelectedSection?.id === section?.id}
            minus={employees.length > 0}
            section={section}
            employee={null}
            onClick={() => onSelectPrimary(section, null)}
            flexBasis={'13.2%'}
            isEmployee={false}
            revenueCentersMap={revenueCentersMap}
            onRemove={() => onUnAssign(section, employees[0])}
          />
          {employees.map(employee =>
            <MergedCard
              key={employee.id}
              minus={true}
              isEmployee={true}
              section={section}
              employee={employee}
              flexBasis={'20%'}
              onRemove={() => onUnAssign(section, employee)}
            />
          )}
        </div>
      )
    })
  );
};

const EmployeesView = props => {
  const {
    employeeList,
    primarySelectedEmployee,
    onSelectPrimary,
    excludeTerminated,
    jobAllowsAssignment,
    jobsMap,
    assigned,
    revenueCentersMap,
    onUnAssign,
  } = props;

  const isVisible = eachEmployee => {
    const { employee, Sections } = eachEmployee;
    let terminatedFlag = true, jobTypeFlag = true, jobAllowsAssignmentFlag = true, assignedFlag = true;

    if (excludeTerminated) { //show only employees where terminated = false
      terminatedFlag = employee.terminated === false;
    }

    if (jobAllowsAssignment) { //show employees that have a job and job.allowEmployeeTableAssignment is true
      const empJob = jobsMap.has(employee.jobId) ? jobsMap.get(employee.jobId) : {};
      jobAllowsAssignmentFlag = empJob?.allowEmployeeTableAssignment === true ? true : false;
    }

    if (assigned) {
      assignedFlag = (Array.isArray(Sections) && Sections.length > 0);
    }

    return (terminatedFlag && jobAllowsAssignmentFlag && jobTypeFlag && assignedFlag);
  };

  return (
    employeeList.map(eachEmployee => {
      const employee = eachEmployee.employee;
      const Sections = Array.isArray(eachEmployee.Sections) ? eachEmployee.Sections : [];
      return (!isVisible(eachEmployee) ? null :
        <div key={employee.id} className={classNames({ [classes.tableGroup]: true, [classes.group]: Sections.length > 0 })}>
          <MergedCard
            active={primarySelectedEmployee && primarySelectedEmployee?.id === employee?.id}
            minus={Sections.length > 0}
            section={null}
            employee={employee}
            isEmployee={true}
            onClick={() => onSelectPrimary(null, employee)}
            flexBasis={'20%'}
            isChild={false}
            onRemove={() => onUnAssign(null, employee)}
          />
          {Sections.map(section =>
            <MergedCard
              key={section.id}
              minus={true}
              employee={employee}
              section={section}
              isEmployee={false}
              flexBasis={'13.2%'}
              revenueCentersMap={revenueCentersMap}
              onRemove={() => onUnAssign(section, employee)}
            />
          )}
        </div>
      )
    })
  );
};
